var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { width: "52", flat: "" } },
    [
      _c("v-select", {
        attrs: { dense: "", items: _vm.items, "hide-details": "" },
        on: {
          change: function ($event) {
            return _vm.$emit("change")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function (ref) {
              var item = ref.item
              return [_c("v-icon", [_vm._v(_vm._s(item.text))])]
            },
          },
          {
            key: "item",
            fn: function (ref) {
              var item = ref.item
              return [_c("v-icon", [_vm._v(_vm._s(item.text))])]
            },
          },
        ]),
        model: {
          value: _vm.computedValue,
          callback: function ($$v) {
            _vm.computedValue = $$v
          },
          expression: "computedValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }